import React, { useEffect, useState, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Card, Col, Modal, Row } from 'react-bootstrap';
import MessageAlertRow from './MessageAlertRow';
import MessageForm from './MessageForm';
import { getEGOperators, getFarmUsers, getIncidenType, getPolicyList } from '../../actions/message-policy';
import { DataTable, Heading5, Icon } from '../widgets';
import '../../../assets/scss/message-policy.scss';

const MessageAlert = () => {
  const { farmId } = useParams();
  const dispatch = useDispatch();

  const [AddPolicy, setAddPolicy] = useState(false);

  const incidentTypes = useSelector(state => state.messagePolicy.incidentTypes);
  const policyList = useSelector(state => state.messagePolicy.list);
  const isRequesting = useSelector(state => state.messagePolicy.isRequesting);
  const farmUsers = useSelector(state => state.messagePolicy.userList);
  const isEGReuesting = useSelector(state => state.equipmentGroup.isRequesting);
  const equipmentGroupList = useSelector(state => state.equipmentGroup.equipmentGroupList);

  useEffect(() => {
    dispatch(getIncidenType(farmId));
    dispatch(getPolicyList(farmId));
    dispatch(getEGOperators(farmId));
    dispatch(getFarmUsers(farmId));
  }, []);

  const { crewList, implementOperatorOptions, truckOperatorOptions } = useMemo(() => {
    let crewListOptions = [];
    let implementOperatorOptions = [];
    let truckOperatorOptions = [];
    let operatorDetails = [];

    if (!equipmentGroupList || equipmentGroupList.length === 0) return { crewList: [], implementOperatorOptions: [], truckOperatorOptions: [] };

    for (const e of equipmentGroupList) {
      if (e.crew.name !== '' && e.alive) crewListOptions.push(e.crew);

      if (e.hasOwnProperty('operator')) {
        operatorDetails = {
          label: e.operator.name,
          value: e.operator.operator_uuid,
        };

        if (operatorDetails.label.trim().length === 0) continue;

        if (e.hasOwnProperty('vehicle') && e.vehicle.is_truck) truckOperatorOptions.push(operatorDetails);
        else implementOperatorOptions.push(operatorDetails);
      }
    }

    const key = 'crew_uuid';
    const crewOptions = [...new Map(crewListOptions.map(item => [item[key], item])).values()];

    let arr = [];
    const entityIds = policyList && policyList.length > 0 ? policyList.map(e => e.entity_uuid) : [];

    for (const item of crewOptions) {
      if (!entityIds.includes(item.crew_uuid)) arr.push(item);
    }

    const crewList = [
      ...arr.map(e => ({
        value: e.crew_uuid,
        label: e.name
      }))
    ];

    return { crewList, implementOperatorOptions, truckOperatorOptions }
  }, [equipmentGroupList]);

  const userList = useMemo(() => {
    if (!farmUsers || farmUsers.length === 0) return [];
    return farmUsers.map(e => ({ label: e.name, value: e.user_id }))
  }, [farmUsers])

  return (
    <div className='message-policy animate animate__slideInUp'>
      <Card className='card-list equipment-list'>
        <Card.Header>
          <Card.Title>
            <Heading5>SMS Configuration List</Heading5>
            <Button
              variant='success'
              size='sm'
              title='Add Configuration'
              className='float-right'
              disabled={isEGReuesting || isRequesting}
              onClick={() => setAddPolicy(!AddPolicy)}>
              <Icon className='fa fa-plus'></Icon> Add
            </Button>
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col>
              <DataTable>
                <DataTable.Header>
                  <DataTable.Row>
                    <DataTable.Cell style={{ width: '40px' }}>#</DataTable.Cell>
                    <DataTable.Cell>Name</DataTable.Cell>
                    <DataTable.Cell>Type</DataTable.Cell>
                    <DataTable.Cell>Phone</DataTable.Cell>
                    <DataTable.Cell>Configuration</DataTable.Cell>
                    <DataTable.Cell style={{ width: '64px' }}>Action</DataTable.Cell>
                  </DataTable.Row>
                </DataTable.Header>
                <DataTable.Body>
                  {policyList.map((e, i) => (
                    <MessageAlertRow
                      data={e}
                      index={i}
                      key={i}
                      farmId={farmId}
                      incidentTypes={incidentTypes}
                      crewList={crewList}
                      userList={userList}
                      truckOperatorOptions={truckOperatorOptions}
                      implementOperatorOptions={implementOperatorOptions}
                    />
                  ))}
                </DataTable.Body>
              </DataTable>
              {isRequesting ? <DataTable.Loading /> :
                policyList.length === 0 && <DataTable.RecordsNotFound />}
            </Col>
          </Row>
        </Card.Body>
      </Card>
      {<Modal
        show={AddPolicy}
        backdrop='static'
        className='equipment-modal-form'>
        <MessageForm
          onHide={(e) => setAddPolicy(e)}
          type={'add'}
          crewList={crewList}
          userList={userList}
          incidentTypes={incidentTypes}
          truckOperatorOptions={truckOperatorOptions}
          implementOperatorOptions={implementOperatorOptions}
        />
      </Modal>}
    </div>
  );
};

export default MessageAlert;